import { render } from "./CauseOfFailure.vue?vue&type=template&id=2ca7de58"
import script from "./CauseOfFailure.vue?vue&type=script&lang=js"
export * from "./CauseOfFailure.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__